// extracted by mini-css-extract-plugin
export var digits = "digits-module--digits--ZUDTp";
export var digits__title = "digits-module--digits__title--XZ9xr";
export var digits__list = "digits-module--digits__list--19hpo";
export var digits__item = "digits-module--digits__item--KiIQ8";
export var digits__itemValue = "digits-module--digits__itemValue--NIhK3";
export var digits__itemDesc = "digits-module--digits__itemDesc--6mPwT";
export var digits__background = "digits-module--digits__background--aQHQb";